import { render, staticRenderFns } from "./SettingsIntegrationsList.vue?vue&type=template&id=cc6a1518&"
import script from "./SettingsIntegrationsList.vue?vue&type=script&lang=js&"
export * from "./SettingsIntegrationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports